module.exports = __webpack_public_path__ + "static/q14-8c364fb62c93e83af90caf95a61a02ba.png";